module.exports = __webpack_public_path__ + "abdc56036d300ba07f70226de839e675.svg";